/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import { Dispatch } from "react";

import { SupportedTheme } from "@vienna/common";

import { setTheme } from "src/store/modules/globalUI";

export const SHORTCUTS: { label: string; applyFunc: (...args: any) => void }[] = [
  {
    label: "color theme: dark mode",
    applyFunc: (dispatch: Dispatch<any>): void => {
      dispatch(setTheme(SupportedTheme.dark));
    },
  },
  {
    label: "color theme: light mode",
    applyFunc: (dispatch: Dispatch<any>): void => {
      dispatch(setTheme(SupportedTheme.light));
    },
  },
  {
    label: "navigation: settings page",
    applyFunc: (): void => {
      window.location.href = "/settings";
    },
  },
  {
    label: "navigation: pages",
    applyFunc: (_dispatch: Dispatch<any>): void => {
      window.location.href = "/home/mine";
    },
  },
  {
    label: "navigation: feed",
    applyFunc: (): void => {
      window.location.href = "/feed";
    },
  },
];
